"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._UpdateCorporateIdentitySettings = exports._InjectStencilWebComponents = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = require("lodash");
var document_translations_1 = require("./document-translations");
var object_service_1 = require("./object-service");
var settings_service_1 = require("./settings.service");
var _InjectStencilWebComponents = function () {
    if ((0, cash_dom_1.default)('#hacktrick-components').length === 0) {
        (0, exports._UpdateCorporateIdentitySettings)();
        // Create and append a script tag for module loading
        var scriptElement = document.createElement('script');
        scriptElement.id = 'hacktrick-components';
        scriptElement.type = 'module';
        scriptElement.textContent = "\n      import { defineCustomElements } from 'https://files.fittec.io/files/new-webcomponents/loader/index.es2017.js'; \n      defineCustomElements();\n    ";
        document.body.appendChild(scriptElement);
    }
};
exports._InjectStencilWebComponents = _InjectStencilWebComponents;
var defaultSettings = {
    allowChangeTheme: false,
    defaultTheme: 'light',
    addGlobalStyles: false, //<- required includes also var styles
    selectedTheme: 'light',
    relativePath: 'https://files.fittec.io/files/new-webcomponents/dist/corpident/shared',
};
var _UpdateCorporateIdentitySettings = function (newSettings) {
    if (newSettings) {
        defaultSettings = (0, lodash_1.merge)({}, defaultSettings, newSettings);
    }
    var doc = document;
    doc.corporateIdentity = __assign({ language: (0, document_translations_1._GetDocumentTranslationLanguage)(object_service_1.ObjectService.getInstance(settings_service_1.SettingsService).get) }, defaultSettings);
};
exports._UpdateCorporateIdentitySettings = _UpdateCorporateIdentitySettings;
